'use client';

import type { FC, JSX } from 'react';
import React, { memo } from 'react';
import type { ImageTypeProps } from '@/components/image/ImageTypeProps';
import dynamic from 'next/dynamic';
const Image = dynamic(() => import('@/components/image/Image'));

const ImageMemoized = memo(Image, (prevProps, nextProps) => {
  return (
    prevProps.image?.imageLink === nextProps.image?.imageLink &&
    prevProps.serverSideContext === nextProps.serverSideContext &&
    prevProps.useDefaultLoader === nextProps.useDefaultLoader &&
    prevProps.noLoader === nextProps.noLoader &&
    prevProps.externalSrc === nextProps.externalSrc &&
    prevProps.src === nextProps.src &&
    prevProps.className === nextProps.className &&
    prevProps.pageProps === nextProps.pageProps &&
    prevProps.pageProps?.currentHost === nextProps.pageProps?.currentHost
  );
});

const ImageWrapper: FC<ImageTypeProps> = (props): JSX.Element => {
  return <ImageMemoized {...props} />;
};

export default ImageWrapper;
